var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-page"},[_c('CategoryHeader'),_c('HighlightedArticles'),_c('HomeArticles',{attrs:{"tag":_vm.categorySlug}}),_c('CategoryList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }